<template>
	<Modal v-if="shown"
		   :width="750" :title="$t('seller.upload.linkProspectiveReceivable.modal.title')"
		   :close-on-click-outside="false"
		   :allow-close="false"
	>
		<template v-slot:body>
			<div class="modal-content text_left" style="overflow: hidden;">
				<span v-html="$t('seller.upload.linkProspectiveReceivable.modal.text')"></span>
				<hr>
				<div class="margin_vertical">
					<span v-html="$t('seller.upload.linkProspectiveReceivable.modal.label.linkTo')"></span>
					<span v-if="errors.has('selectedReceivableIdForLink')" class="validation-error">{{ errors.first("selectedReceivableIdForLink") }}</span>
				</div>
				<form class="flex flex_column scroll_y_auto" style="max-height: calc(100vh - 500px);">
					<md-radio v-for="option in options" :key="option.id"
							  class="md-radio-dense"
							  :class="{ 'md-error': errors.first('selectedReceivableIdForLink') }"
							  v-model="form.selectedReceivableIdToLinkWith"
							  :value="option.value"
							  v-validate="modelValidations.selectedReceivableIdToLinkWith"
							  data-vv-name="selectedReceivableIdForLink"
					>
						{{ option.displayText }}
					</md-radio>
				</form>
				<div v-if="hasSelection" class="text_left light_bg_color margin_top">
					<span v-html="$t('seller.upload.linkProspectiveReceivable.modal.linkNote')"></span>
				</div>
			</div>
			<div class="margin_r margin_top flex flex_end w_100">
				<md-button @click="confirm" :class="{'md-primary': isFormValid}">{{ $t("common.confirm") }}</md-button>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import {formatAsLocalizedDate, formatAsMoneyAmount} from "src/common/format";
import {validateForm, validateRequiredFields} from "@/validation/validation";
import {receivableApi} from "@/common/api/receivableApi";

export default {
	components: {
		Modal
	},
	data() {
		return {
			options: [],
			form: {
				selectedReceivableIdToLinkWith: null,
			},
			modelValidations: {
				selectedReceivableIdToLinkWith: {
					required: true
				}
			},
			shown: false
		};
	},
	computed: {
		hasSelection() {
			return this.form.selectedReceivableIdToLinkWith !== null && this.form.selectedReceivableIdToLinkWith !== 'unlinked';
		},
		isFormValid() {
			return validateRequiredFields(this.form, this.modelValidations);
		},
	},
	methods: {
		showWithDebtorId(debtorId) {
			this.reset();

			receivableApi.inspection.listMatchingProspectiveReceivables(debtorId)
				.then(res => {
					// If there are no links possible, simply keep this hidden
					if (res.length === 0) {
						return;
					}

					this.options = res.map(prospectiveReceivable => {
						return {
							value: prospectiveReceivable.id,
							displayText:
								prospectiveReceivable.invoiceNumber + " " +
								"(" +
								formatAsMoneyAmount(prospectiveReceivable.amount, { currency: prospectiveReceivable.currency }) + ", " +
								this.$t("common.invoiceDate") + ": " + formatAsLocalizedDate(prospectiveReceivable.invoiceDate) + ", " +
								prospectiveReceivable.debtorName +
								")"
						}
					});
					this.options.push({
						value: "unlinked",
						displayText: this.$t("seller.upload.linkProspectiveReceivable.modal.option.unlinked")
					});

					this.shown = true;
				}).catch(this.toast);
		},
		reset() {
			this.prospectiveReceivables = [];
			this.form.selectedReceivableIdToLinkWith= null;

			this.$validator.reset();
		},
		close() {
			this.shown = false;
		},
		confirm() {
			validateForm(this, this.$validator)
				.then(() => {
					if (this.form.selectedReceivableIdToLinkWith !== "unlinked") {
						this.$emit("confirm", this.form.selectedReceivableIdToLinkWith);
					}

					this.close();
				});
		}
	}
};
</script>